<template>
  <div>
    <form-filtered-select
      :selected-key="selectedFlight ? selectedFlight.value : null"
      :options="routeOptions"
      :invalid="invalid"
      placeholder="Flight"
      @updateDropdownValue="onUpdateValue"
      @close="$emit('close')" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: Object,
      default: null
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedFlight: null
    }
  },
  computed: {
    ...mapGetters('dailyCargo', ['routeOptions'])
  },
  watch: {
    value: function () {
      if (this.selectedFlight && this.value.value !== this.selectedFlight.value) {
        this.selectedFlight = this.value
      }
    }
  },
  mounted () {
    this.selectedFlight = this.value
    this.$watch('selectedFlight', function () {
      this.$emit('input', this.selectedFlight)
    })
  },
  methods: {
    onUpdateValue (value) {
      this.selectedFlight = value
    }
  }
}
</script>

<style lang="scss">
.multiselect {
  &__content-wrapper {
    z-index: 3000 !important;
  }
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
